module.exports = __webpack_public_path__ + "static/assets/72d477405d319a5fba908a291af2b628.png";